// Material Dashboard 2 React components
import { Divider } from "@mui/material"
import MDBox from "components/MDBox"
// Dispositivos page components
import Devices from "layouts/dispositivos/components/Devices"
import PropTypes from "prop-types"

function DispositivosInformation({ dispositivos, onDelete, statusCheckVersion }) {
  return (
    <MDBox pt={1} pb={2} px={2}>
      {dispositivos?.map((item) => (
        <div key={item.id}>
          <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
            <Devices
              key={item.id}
              identicador={item.id}
              name={item.description}
              company={
                item.sucursales
                  ? item.sucursales.empresa?.descripcion
                  : item.eventos?.empresa?.descripcion
              }
              branch_office={item.sucursales?.descripcion}
              branch_code={item.sucursales?.codigoEvento}
              event={item.eventos?.descripcion}
              location={item.zonas?.descripcion}
              location_code={item.zonas?.codigoZona}
              type={item.type}
              ip={item.ip}
              nvr={item.nvr}
              estado={item.state}
              enable={item.enable}
              onDelete={onDelete}
              statusCheckVersion={statusCheckVersion}
            />
          </MDBox>
        </div>
      ))}
    </MDBox>
  )
}

DispositivosInformation.propTypes = {
  dispositivos: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDelete: PropTypes.func.isRequired,
  statusCheckVersion: PropTypes.number.isRequired,
}
export default DispositivosInformation
